import { render, staticRenderFns } from "./EditProfileTabs.vue?vue&type=template&id=66ecc3a8&scoped=true"
import script from "./EditProfileTabs.vue?vue&type=script&lang=js"
export * from "./EditProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./EditProfileTabs.vue?vue&type=style&index=0&id=66ecc3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ecc3a8",
  null
  
)

export default component.exports